<template>
  <card-seplag titulo="Cadastro de Exercícios da Declaração">
    <div class="p-grid p-fluid">
      <!-- <div class="p-col-8 p-md-3" >
                <Button style="margin-top:3%;" label="Cadastrar Exercício" class="buttons p-button-info" icon="pi pi-plus" @click="modalExercicio()"/>
                
            </div>   

            <div class="p-col-12"> -->

      <!-- :onExcluirDado="" -->
      <table-seplag v-if="parametroexercicios" :dados.sync="parametroexercicios.content" :hasExibirCabecalho="true"
        :campos="camposTabelaBens" :paginacao="true" :totalRegistro="parametroexercicios.totalElements"
        urlPanagicao="parametroexercicios" :onEditarDado="modalExercicio" :onAdicionarDado="() => modalExercicio()"
        :onExcluirDado="excluirExercicio" hasEventoAcao>
      </table-seplag>
    </div>

    <div id="modalExercicio">
      <Dialog :header="nomeDialogo" :visible.sync="exibirModalExercicio">
        <div class="p-grid p-fluid">
          <div class="p-col-12">
            <template slot="header">
              <span>Selecione o Exercício</span>
            </template>

            <div id="containerCadastroExercicio">
              <div class="p-grid">
                <div class="p-col-12 p-md-6">
                  <label>Selecionar Ano:</label>
                  <Dropdown style="margin-bottom: 15px; padding: 0.3vh" v-model="registro.parametroExercicio.exercicio"
                    :options="exercicios" optionLabel="ano" placeholder="Selecione o Ano" />
                </div>

                <div class="p-col-12 p-md-6">
                  <label>Selecionar Termo:</label>
                  <Dropdown style="margin-bottom: 15px; padding: 0.3vh" v-model="registro.parametroExercicio.termo"
                    :options="termos" :optionLabel="((option) => option['idenTermo'] + ' - ' + option['descTermo'])"
                    placeholder="Selecione o Termo" />
                </div>

                <div class="p-col-12 p-md-6" v-tooltip.top="
                  'Indica o status do registro na tabela (Ativo/Inativo).'">
                  <span class="checkbox">Exercício Ativo</span>
                  <Checkbox :binary="true" v-model="sistemaAtivo" />
                </div>

                <div class="p-col-12 p-md-6" v-tooltip.top="
                  'Indica se o exercício está aberto ou fechado para envio das declarações.'
                ">
                  <span class="checkbox">Exercício Fechado</span>
                  <Checkbox :binary="true" v-model="sistemaFechado" />
                </div>
              </div>

              <hr style="margin: 1rem auto" />

              <div class="p-grid p-fluid">
                <div class="periodoEnvio p-col-12 p-md-6">
                  <p>
                    <strong>Informe o Período de Envio das Declarações</strong>
                  </p>

                  <div class="p-grid">
                    <div class="p-field p-col-12 p-md-4">
                      <label>Data Inicial:</label>
                      <InputMask mask="99/99/9999 99:99:99" v-model="registro.parametroExercicio.dataInicioEnvio"
                        placeholder="99/99/9999 99:99:99" />
                    </div>

                    <div class="p-field p-col-12 p-md-4">
                      <label>Data Final:</label>
                      <InputMask mask="99/99/9999 99:99:99" v-model="registro.parametroExercicio.dataFimEnvio"
                        placeholder="99/99/9999 99:99:99" />
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div @click="ocultarModalExercicio" style="margin-left: 1vw" class="p-col-3 p-md-2" v-if="!acesso">
            <Button label="Voltar" class="p-button-info" />
          </div>
          <div class="p-col-3 p-md-2" v-if="!registro.exercicio.idenExercicio">
            <Button @click="salvarExercicio" label="Salvar" class="p-button-success" />
          </div>
          <div class="p-col-3 p-md-2" v-if="registro.exercicio.idenExercicio">
            <Button @click="editarExercicio" label="Salvar" class="p-button-success" />
          </div>
        </div>
      </Dialog>

      <Confirmacao tituloTela="Confirmação" v-model="abrirPoup" :onConfirmar="confirmarPopup"
        :textoConfirmcao="MensagemAcao" tamanhoTela="" />
    </div>
  </card-seplag>
</template>

<script>
import CardSeplag from "@/template/CardSeplag.vue";
import Confirmacao from "../../../template/Confirmcao";
import TableSeplag from "@/template/TableSeplag.vue";
import { baseApiUrl, printToast } from "@/config/global";

const getCadastroExercicio = () => {
  return {
    parametroExercicio: {
      termo: null,
      dataInicioEnvio: null,
      dataFimEnvio: null,
      dataInicioValidacao: null,
      dataFimValidacao: null,
      flagFechado: null,
      statParExercicio: null,
    },
    exercicio: { idenExercicio: null },
    acao: "NENHUMA",
  };
};
export default {
  name: "cadastroExercicio",
  components: { CardSeplag, TableSeplag, Confirmacao },
  data: function () {
    return {
      exercicios: [],
      termos: [],
      acesso: null,
      permissoesAcesso: null,
      loadingAutorizacoes: false,
      selecionarAno: null,
      selecionarTermo: null,
      dataInicialPeriodoEnvio: null,
      dataFinalPeriodoEnvio: null,
      dataInicialPeriodoValidacao: null,
      dataFinalPeriodoValidacao: null,
      parametroexercicios: null,
      nomeDialogo: "Cadastrar/Habilitar Exercício",
      registro: getCadastroExercicio(),
      exibirModalExercicio: false,
      sistemaAtivo: null,
      sistemaFechado: null,
      abrirPoup: false,
      MensagemAcao: null,
      camposTabelaBens: [
        { nome: "numrAnoCalendario", titulo: "Exercício" },
        { nome: "statParExercicio", titulo: "Status" },
      ],
    };
  },

  methods: {
    carregarDados() {
      this.$http.get(`${baseApiUrl}/exercicios`).then((res) => {
        this.exercicios = res.data;
      });
      this.$http
        .get(`${baseApiUrl}/parametroexercicios/allpage`)
        .then((res2) => {
          this.parametroexercicios = {
            ...res2.data,
            content: [...(res2.data.content || [])].sort(
              (a, b) =>
                Number(b.numrAnoCalendario || 0) -
                Number(a.numrAnoCalendario || 0)
            ),
          };
        });
      this.$http
        .get(`${baseApiUrl}/termosgeral/buscartermosnaovencidosistema`)
        .then((res3) => {
          this.termos = res3.data;
        });
    },

    modalExercicio(dados = null) {
      if (dados) {
        var dadoSelecionado = JSON.parse(JSON.stringify(dados));

        this.registro = {
          parametroExercicio: {
            exercicio: dadoSelecionado.exercicio,
            termo: dadoSelecionado.termo,
            dataInicioEnvio: dadoSelecionado.dataInicioEnvio,
            dataFimEnvio: dadoSelecionado.dataFimEnvio,
            dataInicioValidacao: dadoSelecionado.dataInicioValidacao,
            dataFimValidacao: dadoSelecionado.dataFimValidacao,
            flagFechado: null,
            statParExercicio: null,
            idenParExercicio: dadoSelecionado.idenParExercicio,
          },
          exercicio: { ...dados.exercicio },
          acao: "NENHUMA",
        };
        this.sistemaAtivo = dados.statParExercicio == "INATIVO" ? false : true;
        this.sistemaFechado = dados.flagFechado == "S" ? true : false;
        this.exibirModalExercicio = true;
      } else {
        this.sistemaAtivo = false;
        this.sistemaFechado = false;
        this.registro = getCadastroExercicio();
        this.exibirModalExercicio = true;
      }
    },

    excluirExercicio(dados = null) {
      if (dados) {

        this.$http
          .delete(
            `${baseApiUrl}/parametroexercicios/${dados.idenParExercicio}/inativo`
          )
          .then((res) => {
            printToast({
              severity: "success",
              summary: "Sucesso!",
              detail: res.data,
              life: 3000,
            });
            this.carregarDados();
          });
      }
    },

    onPageAutorizacoes(event) {
      this.$http
        .post(`${baseApiUrl}/seguranca/autorizacaos?page=${event.page}&size=10`)
        .then((res) => {
          this.autorizacoes = res.data;
        });
    },

    atualizarPerfil() { },

    salvarExercicio() {
      let FlagFechado = this.sistemaFechado ? 1 : 0;
      let StatParExercicio = this.sistemaAtivo ? 1 : 0;

      if (this.registro.parametroExercicio.termo) {
        delete this.registro.parametroExercicio.termo.sistema;
      }
      this.registro.parametroExercicio.flagFechado = FlagFechado;
      this.registro.parametroExercicio.statParExercicio = StatParExercicio;

      this.$http
        .post(
          `${baseApiUrl}/parametroexercicios`,
          JSON.stringify(this.registro)
        )
        .then((res) => {
          let retorno = res.data;

          if (!retorno.sucessoExecucao) {
            this.MensagemAcao = retorno.mensagemAcao;
            this.exibirModalExercicio = false;
            this.abrirPoup = true;
          } else {
            this.registro = getCadastroExercicio();
            this.carregarDados();
            printToast({
              severity: "success",
              summary: "Sucesso!",
              detail: "Salvo com sucesso!",
              life: 5000,
            });
            this.exibirModalExercicio = false;
          }
        });
    },

    editarExercicio() {
      let FlagFechado = this.sistemaFechado ? "S" : "N";
      let StatParExercicio = this.sistemaAtivo ? "ATIVO" : "INATIVO";

      delete this.registro.parametroExercicio.termo.sistema;
      this.registro.parametroExercicio.flagFechado = FlagFechado;
      this.registro.parametroExercicio.statParExercicio = StatParExercicio;

      this.$http
        .put(
          `${baseApiUrl}/parametroexercicios/${this.registro.parametroExercicio.idenParExercicio}`,
          JSON.stringify(this.registro)
        )
        .then((res) => {
          let retorno = res.data;

          if (!retorno.sucessoExecucao) {
            this.MensagemAcao = retorno.mensagemAcao;
            this.abrirPoup = true;
          } else {
            this.registro = getCadastroExercicio();
            this.carregarDados();
            printToast({
              severity: "success",
              summary: "Sucesso!",
              detail: "Salvo com sucesso!",
              life: 5000,
            });
          }
          this.exibirModalExercicio = false;
        });
    },

    ocultarModalExercicio() {
      return (this.exibirModalExercicio = false);
    },
    confirmarPopup() {
      this.registro.acao = "ATIVAR";
      this.$http
        .post(
          `${baseApiUrl}/parametroexercicios`,
          JSON.stringify(this.registro)
        )
        .then(() => {
          this.registro = getCadastroExercicio();
          this.carregarDados();
          printToast({
            severity: "success",
            summary: "Sucesso!",
            detail: "Salvo com sucesso!",
            life: 5000,
          });
        });
    },
  },
  mounted() {
    this.carregarDados();
  },
};
</script>

<style scoped>
.buttons {
  font-weight: 650;
  padding: 0.5vw !important;
  width: 12em;
}

.checkbox {
  padding-right: 15px;
  margin-top: 10px;
  font-size: 1rem;
  font-weight: bold;
  color: gray;
}

h4 {
  margin: 1rem auto;
}

#containerCadastroExercicio {
  padding: 1vw;
  border-radius: 5px;
  box-shadow: 1px 3px 8px 0.1px #e0e0e0ce;
}

label {
  margin-top: 1vh;
  margin-bottom: 0.5vh;
  color: gray;
}
</style>